import type { SeatMapOptions } from "@checkout/components";
import type { HopperSeatMapOptions } from "@checkout/components/SeatSelection/types";
import seatMapStyles from "./seatMap.scss?inline";
import { uberVariables } from "@/modules/defaultTheme";

const domainPath =
  import.meta.env.VITE_ENV === "local"
    ? "../../../../../src"
    : window.location.origin;
const fontFile =
  import.meta.env.VITE_ENV === "local"
    ? "UberMoveText-Regular.woff2"
    : "UberMoveText-Regular.4b45e0cd.woff2";

const colors = uberVariables;

// Gordian seat map styles
export const styleString = `@font-face { font-family: "Uber Move Text", sans-serif; font-style: normal; font-weight: normal; src: local("Uber Move Text"), url("${domainPath}/assets/fonts/${fontFile}") format("woff2");}#gordian-seatmap-dialog { font-family: "Uber Move Text", sans-serif !important;}.gr-rounded-lg { border-radius: 0;}`;
export const seatMapOptions: SeatMapOptions = {
  modal: false,
  fontFamily: "Uber Move Text",
  textPrimary: "FF0000", // main text color
  textSecondary: "4B4B4B", // secondary text color
  theme: {
    seats: {
      1: {
        // Standard
        fill: "#BBBBBB",
        stopColor: "#BBBBBB",
        labelColor: colors.black,
      },
      2: {
        // Preferred
        fill: "#A9C9FF",
        stopColor: "#A9C9FF",
        labelColor: colors.black,
      },
      3: {
        // Extra Legroom
        fill: "#7FD99A",
        stopColor: "#7FD99A",
        labelColor: colors.black,
      },
      4: {
        // Exit Row
        fill: "#FFB48C",
        stopColor: "#FFB48C",
        labelColor: colors.black,
      },
      5: {
        // Front Seat
        fill: "#DDB9FF",
        stopColor: "#DDB9FF",
        labelColor: colors.black,
      },
      not_available: {
        fill: "#F3F3F3",
        stopColor: "#F3F3F3",
        borderColor: "#A6A6A6",
      },
      selected_seat: {
        stopColor: colors.black,
        labelColor: colors.white,
      },
    },
  },
};

// Hopper Seat Map styles
export const hopperStyleString = `@font-face { font-family: "Uber Move Text", sans-serif; font-style: normal; font-weight: normal; src: local("Uber Move Text"), url("${domainPath}/assets/fonts/${fontFile}") format("woff2");} ${seatMapStyles}`;
export const hopperSeatMapOptions: HopperSeatMapOptions = {
  seats: {
    standard: {
      background: "#BBBBBB",
      label: colors.black,
    },
    extraLegRoom: {
      background: "#7FD99A",
      label: colors.black,
    },
    exitRow: {
      background: "#FFB48C",
      label: colors.black,
    },
    preferred: {
      background: "#A9C9FF",
      label: colors.black,
    },
    unavailable: {
      background: "#F3F3F3",
      label: colors.black,
    },
    hovered: {
      background: colors.black,
      label: colors.white,
    },
    selected: {
      background: colors.black,
      label: colors.white,
    },
  },
  language: {
    legendCta: "Seat legend",
  },
};
